import { AddressVerificationPostGridApiService } from './address-verification-postgrid-api-service'

export const useAddressVerificationApiService = () => new AddressVerificationPostGridApiService();

export { useCommitteeDocuments } from './use-committee-documents';